import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resendOtp } from "../../store/user/userThunk";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'
const EmailVerification = ({ handleOtpVerify, userEmail, setCode, code }) => {
  const dispatch = useDispatch();
  

  const email = useSelector((state) => state.userservice.email);

  console.log(email ,"emailemailemailemailemailemailemail")
  const inputsRef = useRef([]);

  const handleChange = (value, index) => {
    if (/^\d$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      if (index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault(); // Stop clearing directly
      const newCode = [...code];
      if (newCode[index] !== "") {
        newCode[index] = "";
        setCode(newCode);
      } else if (index > 0) {
        inputsRef.current[index - 1]?.focus();
        const prev = [...code];
        prev[index - 1] = "";
        setCode(prev);
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").trim();
    const digits = paste.replace(/\D/g, "").split("").slice(0, 6);

    if (digits.length === 0) return;

    const newCode = [...code];
    digits.forEach((digit, idx) => {
      newCode[idx] = digit;
      if (inputsRef.current[idx]) {
        inputsRef.current[idx].value = digit;
      }
    });

    setCode(newCode);

    const lastIndex = digits.length - 1;
    if (inputsRef.current[lastIndex]) {
      inputsRef.current[lastIndex].focus();
    }
  };

  const handleVerify = () => {
    const verificationCode = code.join("");
    if (verificationCode.length < 6 || code.includes("")) {
      toast.error("Please enter all 6 digits of the OTP.")
      return;
    }
    if (handleOtpVerify) {
      handleOtpVerify(verificationCode);
    }
  };

  const handleResend = async () => {
    await dispatch(resendOtp(email))
    console.log("Resending code...");
  };

  const maskEmail = (email) => {
    const data = email?.split("@");
    console.log(data, "data")
    const visibleChars = Math.min(6, data[0]?.length);
    const maskedPart = "*".repeat(data[0]?.length - visibleChars);
    return `${data[0]?.slice(0, visibleChars)}${maskedPart}@${data[1]}`;
  };;
  return (
    <div className="verify">
      <div className="verify-card ">
        <div className="verify-icon mb-4">
          <img
            className="mx-auto max-w-[50px]"
            src={require("../../assets/images/login/img-auth-code-varify.png")}
            alt="verify"
          />
        </div>
        <h6 className="text-base/[1.6] font-semibold text-gray-600 mb-0 mt-4">
          Verify OTP
        </h6>
        <p className="text-gray-500 text-sm/[1.6] mt-1 mb-6">
          Enter the OTP sent to your email.
        </p>


        <div className="flex justify-center gap-2 mb-6">
          {code.map((digit, idx) => (
            <input
              key={idx}
              ref={(el) => (inputsRef.current[idx] = el)}
              id={`code-${idx}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e.target.value, idx)}
              onKeyDown={(e) => handleKeyDown(e, idx)}
              onPaste={idx === 0 ? handlePaste : null}
              className="max-w-[50px] w-[100%] h-12 text-center text-xl border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
            />
          ))}
        </div>

        <button
          className="w-full bg-primary text-white font-medium py-2 px-4 text-base rounded-md transition-all hover:shadow-lg hover:shadow-primary/30"
          type="button"
          onClick={() => handleVerify()}
        >
          Verify OTP
        </button>

        <p className="text-center text-sm mt-4">
          Didn’t receive the code?{" "}
          <span
            className="text-primary cursor-pointer font-medium"
            onClick={handleResend}
          >
            Resend Code
          </span>
        </p>
      </div>
    </div>
  );
};

export default EmailVerification;
